<template>
  <main>
    <modalInformacionUsuario :usuario="usuario"></modalInformacionUsuario>
    <page-header-compact
      >Historia Clinica - {{ name_historia }}</page-header-compact
    >
    <br />
    <div class="container-xl px-4">
      <div class="card">
        <cardInformacionUsuario :usuario="usuario"></cardInformacionUsuario>
      </div>
      <br />
      <wizard
        :steps="steps.length"
        @prev="prev($event)"
        @next="next($event)"
        :current_step="current"
      >
        <template #tabs>
          <wizard-tab
            v-for="(step, i) in steps"
            :key="`tab_${i}`"
            :title="step.title"
            :step="i + 1"
            :active="i + 1 === current"
            :id="`step${i + 1}`"
            v-on:tab-click="next({ prev: current, current: i + 1 })"
          ></wizard-tab>
        </template>
        <template #tab-content>
          <wizard-tab-pane id="step1" active="true">
            <template #content>
              <component
                :is="currentComponent.ref"
                :ref="currentComponent.ref"
                v-bind="currentProperties"
              ></component>
            </template>
          </wizard-tab-pane>
        </template>
        <template #finish>
          <cerrar-historia
            :id-usuario="usuario.id"
            :id-historia="idHistoria"
            :usuario="usuario"
          ></cerrar-historia>
        </template>
      </wizard>
    </div>
  </main>
</template>
<script>
import Wizard from "../../../components/common/utilities/Wizard/Wizard";
import WizardTab from "../../../components/common/utilities/Wizard/WizardTab";
import WizardTabPane from "../../../components/common/utilities/Wizard/WizardTabPane";
import motivoConsultaComponent from "../base/motivoConsulta/motivoConsulta";
import examenFisicoComponent from "../base/examenFisico/examenFisico";
import PageHeaderCompact from "../../../components/layouts/content/page-header-compact";
import historiaClinicaService from "../../../services/historiaClinicaService";
import impresionDXComponent from "../base/impresionDX/impresionDXComponent";
import modalInformacionUsuario from "../base/informacionUsuario/modalInformacionUsuario";
import cardInformacionUsuario from "../base/informacionUsuario/cardInformacionUsuario";
import analisisComponent from "../base/baseUrgencia/analisis";
import conductaComponent from "../base/baseUrgencia/conducta";
import revisionComponent from "../base/baseUrgencia/revision";
import ordenComponent from "../base/orden/ordenComponent";
import ordenMedicamentoComponent from "../base/orden/ordenMedicamentoComponent";
import cerrarHistoria from "@/views/historias/base/cerrarHistoria/cerrarHistoria";
import resumenHcComponent from "./resumenHc/resumenHcComponent";
import embarazoService from "@/services/embarazoService";

// violencia sexual
import formViolenciaSexual from "../base/baseRespuestaFormularios/index";
import examenMental from "../base/baseExamenMental/index";
import examenGenitalAnal from "../base/baseExamenGenitalAnal/index";
import riesgoRevictimizacion from "../base/baseRiesgoRevictimizacion/index";
import violenciaSexual from "@/views/historias/base/baseEventosVs/index";
export default {
  components: {
    cerrarHistoria,
    PageHeaderCompact,
    motivoConsultaComponent,
    examenFisicoComponent,
    WizardTabPane,
    WizardTab,
    Wizard,
    impresionDXComponent,
    modalInformacionUsuario,
    cardInformacionUsuario,
    analisisComponent,
    conductaComponent,
    revisionComponent,
    ordenComponent,
    ordenMedicamentoComponent,
    resumenHcComponent,
    // violencia sexual
    formViolenciaSexual,
    examenMental,
    examenGenitalAnal,
    riesgoRevictimizacion,
    violenciaSexual
  },
  data() {
    return {
      finalizada: "",
      idHistoria: "",
      usuario: {},
      ultimoEmbarazo: {},
      current: 1,
      checkpoint: 1,
      name_historia: "",
      codigoTipoHistoria: "",
      triage: {},
    };
  },
  methods: {
    prev(step) {
      this.current = step.current;
      this.activeTab();
    },
    async next(step) {
      if (step.prev <= this.checkpoint && step.current - 1 > step.prev) {
        this.activeTab();
        return;
      }

      const refComponent = this.steps[step.prev - 1].ref;

      if (typeof this.$refs[refComponent].save !== "undefined") {
        await this.$refs[refComponent].save();
      }

      if (this.steps[step.prev - 1].validate) {
        if (this.$refs[refComponent].$v.$invalid) return;
      }

      if (step.current > this.checkpoint) {
        historiaClinicaService.updateCheckpoint(this.idHistoria, step.current);
        this.checkpoint = step.current;
      }

      this.current = step.current;

      this.activeTab();
    },
    async cargar(id) {
      const response = await historiaClinicaService.show(id);

      this.usuario = response.data.usuario;
      this.finalizada = response.data.finalizada;
      this.name_historia = response.data.tipo_historia.nombre;
      this.codigoTipoHistoria = response.data.tipo_historia.codigo;
      this.triage = response.data.urgencia_triage.triage;

      this.ultimoEmbarazo = (
        await embarazoService.showByLast(this.usuario.id)
      )?.data;

      this.current = response.data.checkpoint;
      this.checkpoint = response.data.checkpoint;

      

      this.activeTab();
    },
    activeTab() {
      document.querySelectorAll(`a.active`).forEach((a) => {
        a.classList.remove("active");
      });
      document
        .querySelector(`a[href='${this.steps[this.current - 1].stepId}']`)
        .classList.add("active");
    },
  },
  created() {
    this.idHistoria = this.$route.params.id;
    this.cargar(this.idHistoria);
  },
  computed: {
    currentProperties() {
      if (this.currentComponent.ref === "motivoConsultaComponent") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          modo: "URGENCIA",
          idUsuario: this.usuario.id,
        };
      }
      if (this.currentComponent.ref === "analisisComponent") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
        };
      }
      if (this.currentComponent.ref === "conductaComponent") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
        };
      }
      if (this.currentComponent.ref === "revisionComponent") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
        };
      }
      if (this.currentComponent.ref === "examenFisicoComponent") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          usuario: this.usuario,
          modo: "URGENCIA",
        };
      }
      if (this.currentComponent.ref === "ordenComponent") {
        return {
          idHistoria: this.idHistoria,
          usuario: this.usuario,
          codigoTipoHistoria: this.codigoTipoHistoria,
        };
      }
      if (this.currentComponent.ref === "ordenMedicamentoComponent") {
        return {
          idHistoria: this.idHistoria,
          usuario: this.usuario,
        };
      }
      if (this.currentComponent.ref === "impresionDXComponent") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          modo: "URGENCIA",
          idUsuario: this.usuario.id,
        };
      }
      if (this.currentComponent.ref === "resumenHcComponent") {
        return {
          idHistoria: this.idHistoria,
          idUsuario: this.usuario.id,
        };
      }
      // violencia sexual
      if (this.currentComponent.ref === "formViolenciaSexual") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          idUsuario: this.usuario.id,
          usuario: this.usuario,
          embarazo_actual: this.ultimoEmbarazo,
          codigo: "VIOL_FISICA",
        };
      }
      if (this.currentComponent.ref === "examenMental") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          idUsuario: this.usuario.id,
          usuario: this.usuario,
          embarazo_actual: this.ultimoEmbarazo,
        };
      }
      if (this.currentComponent.ref === "examenGenitalAnal") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          idUsuario: this.usuario.id,
          usuario: this.usuario,
          embarazo_actual: this.ultimoEmbarazo,
        };
      }
      if (this.currentComponent.ref === "riesgoRevictimizacion") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          idUsuario: this.usuario.id,
          usuario: this.usuario,
          embarazo_actual: this.ultimoEmbarazo,
        };
      }

       if (this.currentComponent.ref === "violenciaSexual") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          idUsuario: this.usuario.id,
          usuario: this.usuario,
          embarazo_actual: this.ultimoEmbarazo,
        };
      }

      return {};
    },
    currentComponent() {
      return this.steps[this.current - 1];
    },
    steps() {
      let components = [
        { ref: "motivoConsultaComponent", title: "Motivo Consulta", validate: true },
        { ref: "revisionComponent", title: "Revisión", validate: true },
        { ref: "examenFisicoComponent", title: "Examen Fisico", validate: true },
      ];

      // Insertar componentes de violencia sexual después de examenFisicoComponent
      if (this.triage.codigo_fucsia) {
        components.push(
          {
          ref: "violenciaSexual",
          title: "Eventos Violencia Sexual",
          validate: true,
        },
          { ref: "formViolenciaSexual", title: "Violencia Física VS", validate: true },
          { ref: "examenMental", title: "Examen Mental", validate: true },
          { ref: "examenGenitalAnal", title: "Examen Genital y Anal", validate: true },
          { ref: "riesgoRevictimizacion", title: "Riesgo Revictimización", validate: true }
        );
      }

      components.push(
        { ref: "impresionDXComponent", title: "Impresión Diagnostica", validate: true },
        { ref: "analisisComponent", title: "Analisis", validate: true },
        { ref: "conductaComponent", title: "Conducta", validate: true },
        { ref: "ordenComponent", title: "Procedimientos", validate: false },
        { ref: "ordenMedicamentoComponent", title: "Medicamentos", validate: false },
        { ref: "resumenHcComponent", title: "Resumen", validate: false }
      );

      return components.map((x, i) => ({
        stepId: `#step${i + 1}`,
        ...x,
      }));
    },
  },
};
</script>

<style scoped></style>
